import {
  PROJECT_LIST_EMPTY_STATE_KEYS,
  type ProjectsListEmptyVariant
} from 'constants/project';
import { EMPTY_STRING } from 'constants/general';
import { ProjectLifecycleStatus, ProjectsListViewMode } from 'enums';
import {
  IsTrueZeroProjectsToolbarParams,
  ProjectLifecycleActionVisibility,
  Project
} from 'interfaces/project.interface';

export const resolveProjectLifecycleStatus = (
  project: Pick<Project, 'status'>
): ProjectLifecycleStatus => project.status ?? ProjectLifecycleStatus.ACTIVE;

export const projectMatchesListStatusFilter = (
  project: Pick<Project, 'status'>,
  listStatusFilter: ProjectLifecycleStatus
): boolean => resolveProjectLifecycleStatus(project) === listStatusFilter;

export const getProjectsListEmptyVariant = (
  listStatusFilter: ProjectLifecycleStatus,
  debouncedSearch: string
): ProjectsListEmptyVariant => {
  if (debouncedSearch.trim().length > 0) {
    return 'search';
  }
  if (listStatusFilter === ProjectLifecycleStatus.COMPLETED) {
    return 'completed';
  }
  if (listStatusFilter === ProjectLifecycleStatus.ARCHIVED) {
    return 'archived';
  }
  return 'active_zero';
};

export const getProjectsListEmptyCopyKeys = (
  listStatusFilter: ProjectLifecycleStatus,
  debouncedSearch: string
) =>
  PROJECT_LIST_EMPTY_STATE_KEYS[
    getProjectsListEmptyVariant(listStatusFilter, debouncedSearch)
  ];

export const isTrueZeroProjectsToolbar = ({
  listViewMode,
  listStatusFilter,
  debouncedSearch,
  isProjectsLoading,
  projectCount
}: IsTrueZeroProjectsToolbarParams): boolean =>
  listViewMode === ProjectsListViewMode.ALL &&
  !isProjectsLoading &&
  projectCount === 0 &&
  listStatusFilter === ProjectLifecycleStatus.ACTIVE &&
  debouncedSearch.trim() === EMPTY_STRING;

export const getProjectLifecycleActionVisibility = (
  status: ProjectLifecycleStatus
): ProjectLifecycleActionVisibility => ({
  showMarkComplete: status === ProjectLifecycleStatus.ACTIVE,
  showArchive: status !== ProjectLifecycleStatus.ARCHIVED,
  showRestore: status !== ProjectLifecycleStatus.ACTIVE
});
